import React from 'react'
import { NewTable } from '../../../../../components'
import { mapTableRows } from '../../../../../utils';

const ProcessingPage = () => {
  const columns = [
    {
      key: "employee",
      label: "Employee",
    },
    {
      key: "JobTitle",
      label: "Job Title",
    },
    {
      key: "client",
      label: "Client",
    },
    {
      key: "invoiceFrequence",
      label: "Invoice Frequence",
    },
    {
      key: "invoicePeriod",
      label: "invoice Period",
    },
    {
      key: "Timesheet Dates",
      label: "TimesheetDates",
    },
    {
      key: "Total Hours",
      label: "TotalHours",
    },
  ];
  const tableData = [];
  const mappedRows = mapTableRows(tableData, columns);
  return (
    <div>
    <NewTable
      rows={mappedRows}
      columns={columns}
      toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
    />
  </div>
  )
}

export default ProcessingPage